//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serveLeaveMessageAddAndEdit } from "@/api/managementCenter/advices";
export default {
  name: "addLeave",
  components: {},
  props: [],
  data: function data() {
    return {
      show: false,
      loading: false,
      serveName: "",
      form: {
        title: "",
        eventLocation: "",
        content: "",
        serveId: "",
        privateFlag: 1
      },
      rules: {
        content: [{
          required: true,
          message: "请输入留言内容",
          trigger: "blur"
        }],
        privateFlag: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  computed: {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(id, name) {
      // 重置表单、显示弹框
      this.show = true;
      this.serveName = name;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();
        this.form.serveId = id;
      });
    },
    serveLeaveMessageAdd: function serveLeaveMessageAdd() {
      var _this = this;

      this.loading = true;
      serveLeaveMessageAddAndEdit(this.form).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.$message.success("留言成功!");

          _this.show = false;

          _this.$emit("saveSuccess");
        } else {
          _this.$message.warning(data.msg || "留言失败");
        }
      }).catch(function (err) {
        _this.loading = false;

        _this.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.serveLeaveMessageAdd();
        } else {
          return false;
        }
      });
    }
  },
  watch: {},
  filters: {}
};